import React from "react";

export const ArrowPrev: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8.8 15.99">
    <path
      d="M1.93,8L8.57,1.37c.31-.31,.31-.82,0-1.13-.31-.31-.82-.31-1.13,0L.23,7.43c-.31,.31-.31,.82,0,1.13l7.2,7.2c.31,.29,.79,.29,1.1,0,.32-.3,.33-.81,.03-1.13L1.93,8Z"
      fillRule="evenodd"
    />
  </svg>
);
